import {
  FormField,
  MultiRadioFormFieldIcon,
} from '@domgen/dgx-fe-forms/layout';
import { PopularVideos } from '../../your-appliance/cms/cms-popular-videos.interface';

export interface CmsApplianceDetailsForm {
  applianceCategoryField: MultiRadioFormFieldIcon;
  applianceCodeField: FormField;
  popularVideosBlock: PopularVideos;
}
